import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import IntegrationBox from './IntegrationBox';
import { getIntegrations, getIntegrationTools } from '../../store/Integration';
import TableAnimationFiles from '../Animations/TableAnimationFiles.js';

const AppsTab = (props) => {
    const dispatch = useDispatch();
    const { currentWorkspace } = useSelector(state => state['Settings']);
    const tools = useSelector(state => state['Integration']?.['tools']?.['data'] || []);
    const integrations = useSelector(state => state['Integration']?.['integrations'] || []);
    
    const userRole = currentWorkspace?.['role'] || 'view';
    const canManageIntegrations = ['owner', 'admin', 'editor'].includes(userRole);

    useEffect(() => {
        // Fetch integrations and tools on component mount
        dispatch(getIntegrations());
        dispatch(getIntegrationTools());
    }, []);

    // Filter active tools with type 'tool' only
    const activeTools = tools.filter(tool => tool['isActive'] !== false && tool['type'] === 'tool');

    return (
        <div className='integrations-tab'>
            <div className='title-top-block'>
                <div className='left-area'>
                    <h2>Integrations</h2>
                </div>
                <div className='right-btns'>
                    {/* <button className='btn-style-border'><i className='fa fa-download'></i> Download Invoice</button> */}
                    {/* <button className='btn-style-new'>Save Workspace</button> */}
                </div>
            </div>
            <div className='integrations-inner'>
                {!activeTools || activeTools.length === 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                        <TableAnimationFiles />
                    </div>
                ) : (
                    <div className='row'>
                        {activeTools.map(tool => {
                            // Get ALL integrations for this tool (multi-account support + public from others)
                            const toolIntegrations = integrations.filter(int => {
                                if (!int['toolId']) return false;
                                const intToolId = (int['toolId']['_id'] || int['toolId']).toString();
                                const currentToolId = tool['_id'].toString();
                                return intToolId === currentToolId;
                            });

                            return (
                                <IntegrationBox
                                    tool={tool}
                                    key={tool['_id']}
                                    integrations={toolIntegrations}
                                    canManageIntegrations={canManageIntegrations}
                                />
                            );
                        })}
                    </div>
                )}
            </div>

        </div>
    )
}

export default AppsTab;